import { api } from "@/services/api";
import { AuthStore } from "@/stores/Auth";
import { bloqueia_campos } from "./functions";
import { toastr } from "@/plugins/toast";

export async function cadastrar(uri, dados) {
  const auth = AuthStore()
  bloqueia_campos()
  try {
    const data = await api.post(uri, dados, { Authorization: auth.token }, false);
    
    if (data?.status >= 400) {
      for (const key in data.message) {
        toastr.erro(data.message[key]);
      }
      bloqueia_campos(false)
      return false
    } else if (data?.status == 200) {
      toastr.sucesso(data.message)

      for (const key in data.messageError) {
        toastr.erro(data.messageError[key]);
      }

      bloqueia_campos(false)
      document.querySelector("#btn_close_modal_cadastrar").click()
      return true
    } else {
      toastr.erro("Erro ao realizar o cadastro, tente novamente dentro de alguns minutos.")
      bloqueia_campos(false)
      return false
    }
  } catch (error) {
    toastr.erro("Erro ao cadastrar.");
    bloqueia_campos(false)
    return false
  }
}

export async function editar_status(uri, dados) {
  const auth = AuthStore()
  try {
    var sts = (dados.cellData == 'Ativo' ? 'Inativo' : 'Ativo')
    var id = dados.rowData.id
    var autoriza = await api.autoriza();

    const stat = {
      status: sts,
      id: id,
    }

    if (autoriza) {
      try {
        const data = await api.post(uri, stat, { Authorization: auth.token })
        if (data.status == 200) {
          var mgn = `Status de ${dados.rowData.nome_pagamento} alterado para ${sts}`;
          if (sts == 'Ativo') {
            toastr.sucesso(mgn)
          } else {
            toastr.alerta(mgn)
          }
          return true
        } else {
          toastr.erro('Erro ao alterar o status, tente novamente em alguns instantes.')
          return false
        }
      } catch (error) {
        toastr.erro('Erro ao se comunicar com a API, tente novamente em alguns instantes.')
        return false
      }
    } else {
      toastr.erro("É preciso estar logado como administrador para esta ação.")
      return false
    }
  } catch (error) {
    toastr.erro("Erro na solicitação, tente novamente em alguns instantes.")
    return false
  }
}

export async function deletar(uri, dados) {
  const auth = AuthStore()
  bloqueia_campos()
  var id = dados.id
  const autoriza = await api.autoriza();
  const data = {
    id: id,
  }
  var retorno = false
  if (autoriza) {
    try {
      var deletar = await api.post(uri, data, { Authorization: auth.token })
      if (deletar.status == 200) {
        toastr.sucesso(deletar.message)
        document.querySelector("#btn_close_modal_delete").click()
        retorno = true
      } else {
        toastr.erro(deletar.message)
        retorno = false
      }
    } catch (error) {
      toastr.erro(error)
      retorno = false
    }
  }
  bloqueia_campos(false);
  return retorno;
}